(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.rm-reveal:not([data-ready])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { e.setAttribute('data-ready', ''); io.observe(e); });
  }

  /* ---------- arcade: playable pixel runner on a CRT TV ---------- */
  var SPR = {
    hero: ['..1111..', '.111111.', '.12121..', '.111111.', '..1111..', '.333333.', '3.3333.3', '..4..4..'],
    hero2: ['..1111..', '.111111.', '.12121..', '.111111.', '..1111..', '.333333.', '3.3333.3', '.4....4.'],
    blob: ['..5555..', '.555555.', '55255255', '55555555', '55555555', '.5.55.5.'],
    coin: ['.66.', '6776', '6776', '.66.']
  };
  var PAL = { 1: '#ffd9b3', 2: '#1b1530', 3: '#ff3ea5', 4: '#22e3ff', 5: '#7c4dff', 6: '#ffd23f', 7: '#fff3b0' };

  function drawSprite(ctx, s, x, y, k) {
    for (var r = 0; r < s.length; r++) for (var c = 0; c < s[r].length; c++) {
      var ch = s[r][c]; if (ch === '.') continue;
      ctx.fillStyle = PAL[ch]; ctx.fillRect(Math.round(x + c * k), Math.round(y + r * k), k, k);
    }
  }

  function initArcade(root) {
    root.querySelectorAll('[data-rm-arcade]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var sec = wrap.closest('.rm-section') || wrap;
      var cv = wrap.querySelector('canvas');
      var ctx = cv.getContext('2d');
      var W = 320, H = 180, K = 3, GROUND = 148;
      var power = sec.querySelector('[data-rm-power]');
      var jumpBtn = sec.querySelector('[data-rm-jump]');
      var scoreEl = sec.querySelector('[data-rm-score]');
      var bestEl = sec.querySelector('[data-rm-best]');
      var cta = sec.querySelector('[data-rm-after]');
      var labels = { start: wrap.getAttribute('data-start') || 'NACIŚNIJ START', over: wrap.getAttribute('data-over') || 'KONIEC GRY' };
      var st = { on: false, mode: 'off', t: 0, y: GROUND - 24, vy: 0, obs: [], coins: [], score: 0, speed: 2.2, best: 0, raf: 0, last: 0, stars: [] };
      try { st.best = parseInt(localStorage.getItem('rm-best') || '0', 10) || 0; } catch (e) {}
      if (bestEl) bestEl.textContent = st.best;
      for (var i = 0; i < 40; i++) st.stars.push([Math.random() * W, Math.random() * 100, Math.random()]);

      function reset() { st.y = GROUND - 24; st.vy = 0; st.obs = []; st.coins = []; st.score = 0; st.speed = 2.2; st.t = 0; }
      function jump() {
        if (!st.on) return;
        if (st.mode === 'title' || st.mode === 'over') { reset(); st.mode = 'play'; if (cta) cta.classList.remove('is-shown'); return; }
        if (st.y >= GROUND - 24 - .5) st.vy = -6.4;
      }
      function text(s, y, size, color) {
        ctx.font = '700 ' + size + 'px "Pixelify Sans", monospace'; ctx.textAlign = 'center'; ctx.fillStyle = color; ctx.fillText(s, W / 2, y);
      }
      function bg() {
        var g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#1a0f3d'); g.addColorStop(1, '#3a1460');
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
        st.stars.forEach(function (s) { ctx.fillStyle = 'rgba(255,255,255,' + (0.3 + 0.5 * Math.abs(Math.sin(st.t / 30 + s[2] * 6))) + ')'; ctx.fillRect((s[0] - st.t * 0.2 * s[2] + W * 10) % W, s[1], 1, 1); });
        ctx.fillStyle = '#ff3ea5'; ctx.beginPath(); ctx.arc(250, 60, 22, 0, Math.PI * 2); ctx.fill();
        for (var b = 0; b < 6; b++) { ctx.fillStyle = '#1a0f3d'; ctx.fillRect(228, 48 + b * 6, 44, 2); }
        ctx.fillStyle = '#2a1a5e';
        for (var m = 0; m < 5; m++) { var mx = ((m * 90 - st.t * 0.5) % 450 + 450) % 450 - 60; ctx.beginPath(); ctx.moveTo(mx, GROUND); ctx.lineTo(mx + 50, GROUND - 46); ctx.lineTo(mx + 100, GROUND); ctx.fill(); }
        ctx.fillStyle = '#22e3ff'; ctx.fillRect(0, GROUND, W, 2);
        ctx.fillStyle = '#120a2b'; ctx.fillRect(0, GROUND + 2, W, H - GROUND);
        ctx.fillStyle = 'rgba(34,227,255,.35)';
        for (var x = 0; x < W + 20; x += 20) { var gx = (x - (st.t * st.speed) % 20); ctx.fillRect(gx, GROUND + 8, 10, 2); }
      }
      function frame(now) {
        st.raf = requestAnimationFrame(frame);
        if (now - st.last < 15) return; st.last = now; st.t++;
        bg();
        if (st.mode === 'title') {
          drawSprite(ctx, (st.t >> 3) % 2 ? SPR.hero : SPR.hero2, 60, GROUND - 24, K);
          if ((st.t >> 4) % 2) text(labels.start, 96, 13, '#ffd23f');
          text('RETRO', 56, 26, '#ff3ea5');
        } else if (st.mode === 'play' || st.mode === 'over') {
          if (st.mode === 'play') {
            st.vy += 0.32; st.y = Math.min(GROUND - 24, st.y + st.vy);
            st.speed = Math.min(5.2, 2.2 + st.score / 400);
            if (st.t % Math.max(48, 96 - Math.floor(st.score / 40)) === 0 && Math.random() > 0.25) st.obs.push({ x: W + 10 });
            if (st.t % 70 === 0) st.coins.push({ x: W + 10, y: GROUND - 40 - Math.random() * 40, got: false });
            st.obs.forEach(function (o) { o.x -= st.speed; });
            st.coins.forEach(function (c) { c.x -= st.speed; });
            st.obs = st.obs.filter(function (o) { return o.x > -30; });
            st.coins = st.coins.filter(function (c) { return c.x > -20 && !c.got; });
            st.score++;
            st.obs.forEach(function (o) { if (o.x < 60 + 20 && o.x + 22 > 62 && st.y + 24 > GROUND - 16) { st.mode = 'over'; if (st.score > st.best) { st.best = st.score; try { localStorage.setItem('rm-best', st.best); } catch (e) {} } if (bestEl) bestEl.textContent = st.best; if (cta) cta.classList.add('is-shown'); } });
            st.coins.forEach(function (c) { if (Math.abs(c.x - 66) < 16 && Math.abs(c.y - st.y) < 22) { c.got = true; st.score += 100; } });
          }
          st.coins.forEach(function (c) { drawSprite(ctx, SPR.coin, c.x, c.y + Math.sin(st.t / 6) * 2, K); });
          st.obs.forEach(function (o) { drawSprite(ctx, SPR.blob, o.x, GROUND - 18, K); });
          drawSprite(ctx, (st.t >> 2) % 2 ? SPR.hero : SPR.hero2, 60, st.y, K);
          ctx.font = '700 11px "Pixelify Sans", monospace'; ctx.textAlign = 'left'; ctx.fillStyle = '#fff'; ctx.fillText(String(st.score).padStart(5, '0'), 10, 18);
          if (scoreEl) scoreEl.textContent = st.score;
          if (st.mode === 'over') { ctx.fillStyle = 'rgba(13,11,26,.55)'; ctx.fillRect(0, 0, W, H); text(labels.over, 80, 18, '#ff3ea5'); if ((st.t >> 4) % 2) text(labels.start, 106, 12, '#ffd23f'); }
        }
      }
      function turnOn() {
        st.on = !st.on;
        wrap.classList.toggle('is-on', st.on);
        if (power) { power.setAttribute('aria-pressed', st.on ? 'true' : 'false'); power.textContent = '⏻ ' + (st.on ? (power.getAttribute('data-off') || 'Wyłącz') : (power.getAttribute('data-on') || 'Włącz')); }
        if (st.on) { st.mode = 'title'; reset(); cancelAnimationFrame(st.raf); st.raf = requestAnimationFrame(frame); }
        else { cancelAnimationFrame(st.raf); ctx.fillStyle = '#05040b'; ctx.fillRect(0, 0, W, H); if (cta) cta.classList.remove('is-shown'); }
      }
      ctx.fillStyle = '#05040b'; ctx.fillRect(0, 0, W, H);
      if (power) power.addEventListener('click', turnOn);
      if (jumpBtn) jumpBtn.addEventListener('pointerdown', function (e) { e.preventDefault(); if (!st.on) turnOn(); else jump(); });
      cv.addEventListener('pointerdown', function (e) { e.preventDefault(); if (!st.on) turnOn(); else jump(); });
      document.addEventListener('keydown', function (e) {
        if (!st.on || (e.code !== 'Space' && e.code !== 'ArrowUp')) return;
        var r = wrap.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        e.preventDefault(); jump();
      });
    });
  }

  /* ---------- bundle picker under Dawn buy button (sets quantity) ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (fmt || '{{amount}} zł').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function initBundles(root) {
    root.querySelectorAll('[data-rm-bundles]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var form = document.querySelector('form[action*="/cart/add"][id^="product-form"]') || document.querySelector('product-form form');
      var section = box.closest('section, .shopify-section') || document;
      var fmt = box.getAttribute('data-format');
      function qtyInput() { return section.querySelector('input[name="quantity"]') || document.querySelector('quantity-input input[name="quantity"]'); }
      function price() {
        var id = form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
        var data = JSON.parse(box.querySelector('script').textContent);
        var v = data.filter(function (x) { return String(x.id) === String(id); })[0] || data[0];
        return v.price;
      }
      function render() {
        var p = price();
        box.querySelectorAll('[data-qty]').forEach(function (opt) {
          var q = +opt.getAttribute('data-qty'), d = +opt.getAttribute('data-off');
          var total = Math.round(p * q * (100 - d) / 100);
          opt.querySelector('[data-total]').textContent = money(total, fmt);
          var full = opt.querySelector('[data-full]'); if (full) full.textContent = d ? money(p * q, fmt) : '';
          var each = opt.querySelector('[data-each]'); if (each) each.textContent = money(Math.round(total / q), fmt);
        });
      }
      box.addEventListener('change', function (e) {
        if (!e.target.matches('input[type=radio]')) return;
        var q = e.target.closest('[data-qty]').getAttribute('data-qty');
        var qi = qtyInput(); if (qi) { qi.value = q; qi.dispatchEvent(new Event('change', { bubbles: true })); }
        box.querySelectorAll('[data-qty]').forEach(function (o) { o.classList.toggle('is-active', o.contains(e.target)); });
      });
      document.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(render, 60); });
      render();
    });
  }

  /* ---------- final CTA: price follows the selected variant ---------- */
  function initFinal(root) {
    root.querySelectorAll('[data-rm-final]:not([data-ready])').forEach(function (f) {
      f.setAttribute('data-ready', '');
      var sel = f.querySelector('select[name="id"]'); var out = f.querySelector('[data-rm-final-price]');
      if (!sel || !out) return;
      function upd() { var o = sel.options[sel.selectedIndex]; out.textContent = o.getAttribute('data-price'); }
      sel.addEventListener('change', upd); upd();
    });
  }

  function init(root) { root = root || document; initReveal(root); initArcade(root); initBundles(root); initFinal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
